import { render, staticRenderFns } from "./battery.vue?vue&type=template&id=2be1d85f&scoped=true&"
import script from "./battery.vue?vue&type=script&lang=js&"
export * from "./battery.vue?vue&type=script&lang=js&"
import style0 from "./battery.vue?vue&type=style&index=0&id=2be1d85f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be1d85f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VLayout})
